/*
ashraf 09/26/2022 2698811066 changed label for copy address and contacts
saikrishna 10/03/2022 2698811066 Feature: Added three fields in multiple places wherever required in client management
ashraf 10/03/2022  2698811066 fixed alignments at service type rate card dropdowns
saikrishna 10/03/2022 2698811066 Bugfixes: fixed validation bugs in wellfund dropdown.
saikrishna 10/03/2022 2698811066 Fixed merge conflicts
saikrishna 10/04/2022 2698811066 bugFix: Fixed CM bugs
saikrishna 10/06/2022 2698811066  Removed unecesarry console.log statements
ashraf 10/10/2022 2698811066 fixed role based access, client maintenance edit rate popup issues
saikrishna 10/13/2022 2698811066  ClientMaintenance Fixed GAL- 461 , 463 bugs
Suresh Peddavoora 10/30/2022 2698811066  Added Class Name for Table and Button Enhancements
*/

import React, {useEffect, useState, useContext, memo} from 'react';
import {
  TextField,
  FormControl,
  Button,
  Checkbox,
  FormHelperText,
  Typography,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {useHistory} from 'react-router';
import LandingPage from '../../LandingPage';
import {ArrowBack} from '@material-ui/icons';
import {NumberOnly} from '../../../util/Currency';
import moment from 'moment';
import {getObject} from '../../../util/GetDropdownObject';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
import {
  fetchDropDowns,
  resetMessage,
  resetStatus,
  fetchClientService,
  fetchClientParent,
  getSubServiceTypes,
  getServiceType,
  postClientCode,
  resetClientCodes,
  postClientName,
  resetNameCodes,
  getClientAddress,
  resetClientAddress,
  resetSubServiceTypes,
  fetchAllClientCodes,
  fetchAllClientName,
} from '../../../redux/reducers/client-maintainance/ClientGeneral';
import PageLoader from '../../../components/PageLoader';
import * as Yup from 'yup';
import DialogBox from '../../../components/DialogBox';
import ClientConfirmationForm from './ClientConfirmationForm';
import {ThemeContext} from '../../../themes/ThemeProvider';
import ClientFormSubServiceTypeTable from './ClientFormSubServiceTypeTable';
import {Form, Formik} from 'formik';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';


const RenderAddress = ({addressData, dropDownData, title}) => {
  return (
    <>
      <div
        className="col-sm-6"
        style={{
          textAlign: 'justify',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          marginBottom: '1rem',
          marginLeft: '0.5rem',
          letterSpacing: '0.4px',
          fontSize: '0.9rem',
        }}
      >
        <b style={{fontSize: '1rem'}}>{title}: </b>
        <span>
          {addressData.addressLine1 +
            (addressData.addressLine1 ? ', ' : ' ') +
            addressData.addressLine2 +
            (addressData.addressLine2 ? ', ' : ' ') +
            addressData.city +
            ', '}
        </span>
        <span>
          {addressData?.state ?
            getObject(addressData.state, 'STATE', dropDownData).value :
            ''}
        </span>
        <span>
          {addressData.zip && ', ' + addressData.zip + '.'}
        </span>
      </div>
    </>
  );
};


const ClientForm = memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    dropDownData,
    clientGeneralStatus,
    isLoading,
    clientServiceData,
    clientParentData,
    clientCodeData,
    clientNameData,
    clientAddressData,
    subServiceTypes,
    serviceTypes,
    allClientCodeData,
  } = useSelector(({clientGeneral}) => clientGeneral);
  const {roleData} = useSelector(({role}) => role);

  // const [clientId, setclientId] = useState(null);
  const clientId = null;

  useEffect(() => {
    if (roleData &&
     Object.keys(roleData) &&
     roleData?.window &&
     !roleData?.window?.['Client Maintenance']?.AC?.read) {
      history.replace('/account-summary');
    }
  }, [roleData]);

  const getCommonOptions = (data) => {
    if (data?.length > 0) {
      return data;
    } else {
      return [];
    }
  };
  const initialVal = {
    clientName: '',
    phoneNumber: '',
    addressLine1: clientAddressData?.addressLine1 ? clientAddressData.addressLine1 : '',
    addressLine2: clientAddressData?.addressLine2 ? clientAddressData.addressLine2 : '',
    city: clientAddressData?.city ? clientAddressData.city : '',
    zipCode: clientAddressData?.zip ? clientAddressData.zip : '',
    contactName: '',
    clientNumber: '',
    locationCode: '',
    classOfClient: '',
    parentClientId: '',
    state: clientAddressData?.state ?
      getObject(clientAddressData.state, 'STATE', dropDownData) :
      '',
    isActive: true,
    serviceType: [],
    companyType: '',
    subServiceType: [],
  };

  const [inputValue, setInputValue] = useState('');
  const [inputValue1, setInputValue1] = useState('');
  const existingClients = (clients) => {
    const existingClientsArray = [];
    if (clients?.length > 0) {
      for (const i in clients) {
        if (clients.hasOwnProperty(i)) {
          existingClientsArray.push(clients[i] || (clients[i] && clients[i].clientNumber));
        }
      }
      return existingClientsArray;
    }
  };
  useEffect(() => {
    if (clientNameData?.length > 0 && inputValue?.length > 0) {
      setOpenMenu(true);
      existingClients(clientNameData);
    } else {
      setOpenMenu(false);
    }
  }, [inputValue, clientNameData]);

  useEffect(() => {
    if (clientCodeData?.length > 0 && inputValue1?.length > 0) {
      setNumberMenu(true);
      existingClients(clientCodeData);
    } else {
      setNumberMenu(false);
    }
  }, [inputValue1, clientCodeData]);

  const [openMenu, setOpenMenu] = useState(false);
  const [numberMenu, setNumberMenu] = useState(false);
  window.onclick = function() {
    setOpenMenu(false);
    setNumberMenu(false);
  };

  const checkCodeExist = (value) => {
    if (allClientCodeData && allClientCodeData?.length > 0 && value) {
      const exist = allClientCodeData.filter((i) => {
        const number = /^\d/.test(i?.clientNumber) && i?.clientNumber?.match(/\d+/g);
        return number && number.length > 0 && number[0] === value;
      });
      return exist.length > 0;
    } else {
      return false;
    }
  };

  const checkNameExist = (value) => {
    if (clientNameData && clientNameData?.length > 0 && value) {
      const ar = [];
      clientNameData.filter((i) => {
        if (i?.toLowerCase()?.trim() === value?.toLowerCase()?.trim()) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const validation = {};
  subServiceTypes &&
    subServiceTypes.length > 0 &&
    subServiceTypes.forEach((type) => {
      const {subServiceTypeId} = type;
      validation[`debtorOverPayments${subServiceTypeId}`] = Yup.string()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string()
            .notOneOf(['none'], 'Debtor Over payments Remitted is required')
            .required('Debtor Over payments Remitted is required'),
          otherwise: Yup.string(),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string()
            .notOneOf(['none'], 'Debtor Over payments Remitted is required')
            .required('Debtor Over payments Remitted is required'),
          otherwise: Yup.string(),
        });
      validation[`inflationAgreement${subServiceTypeId}`] = Yup.string()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string()
            .notOneOf(['none'], 'Inflation agreement is required')
            .required('Inflation agreement is required'),
          otherwise: Yup.string(),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string()
            .notOneOf(['none'], 'Inflation agreement is required')
            .required('Inflation agreement is required'),
          otherwise: Yup.string(),
        });
      validation[`postageAgreement${subServiceTypeId}`] = Yup.string()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string()
            .notOneOf(['none'], 'Postage agreement is required')
            .required('Postage agreement is required'),
          otherwise: Yup.string(),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string()
            .notOneOf(['none'], 'Postage agreement is required')
            .required('Postage agreement is required'),
          otherwise: Yup.string(),
        });
      validation[`rateType${subServiceTypeId}`] = Yup.string()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string()
            .notOneOf(['none'], 'Rate type is required')
            .required('Rate type is required'),
          otherwise: Yup.string(),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string()
            .notOneOf(['none'], 'Rate type is required')
            .required('Rate type is required'),
          otherwise: Yup.string(),
        });
      validation[`value${subServiceTypeId}`] = Yup.string()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string().required('Value is required'),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string().required('Value is required'),
        })
        .test('is not 100', 'Value should not be greater than 100', function(fieldValue, context) {
          if (
            context?.parent[`rateType${subServiceTypeId}`] &&
              context?.parent[`rateType${subServiceTypeId}`] === 'percentage' &&
            Number(fieldValue) > 100
          ) {
            return false;
          } else {
            return true;
          }
        }).test('is Negative', 'Value can\'t be negative', function(fieldValue, context) {
          if (
            context?.parent[`rateType${subServiceTypeId}`] &&
            (context?.parent[`rateType${subServiceTypeId}`] === 'percentage' || context.parent[`rateType${subServiceTypeId}`] === 'flat') &&
            Number(fieldValue) < 0
          ) {
            return false;
          } else {
            return true;
          }
        });
      validation[`effectiveDate${subServiceTypeId}`] = Yup.string()
        .nullable()
        .when(`companyType`, {
          is: (value) => value !== 'The WellFund, LLC',
          then: Yup.string().nullable().required('Effective date is required'),
        })
        .when(`selected${subServiceTypeId}`, {
          is: true,
          then: Yup.string().nullable().required('Effective date is required'),
        })
        .test('is valid date', 'Invalid date', (value) => {
          if (value === 'Invalid Date' && value) {
            return false;
          } else {
            return true;
          }
        })
        .test('min Date', 'Start date cannot be a past date', (value) => {
          if (
            value &&
            value !== 'Invalid Date' &&
            new Date(value)?.setHours(0, 0, 0, 0) < new Date()?.setHours(0, 0, 0, 0)
          ) {
            return false;
          } else {
            return true;
          }
        });
      validation[`rateNote${subServiceTypeId}`] = Yup.string().max(500, 'Notes cannot exceed 500 characters');

      validation[`endDate${subServiceTypeId}`] = Yup.string()
        .nullable()
        .test('length', 'End date should not be below the effective date', function(date, context) {
          const effectiveDate = moment(context.parent[`effectiveDate${subServiceTypeId}`]).format(
            'YYYY-MM-DD',
          );
          const endDate = moment(date).format('YYYY-MM-DD');
          if (date === undefined || endDate >= effectiveDate) {
            return true;
          } else {
            return false;
          }
        })
        .test('is valid date', 'Invalid date', (value) => {
          if (value === 'Invalid Date' && value) {
            return false;
          } else {
            return true;
          }
        });
    });
  const validationShape = {
    parentClientId: Yup.mixed().test('parentClientId', 'Parent client is required', (value) => {
      if (!value?.parentClientId) {
        return false;
      } else {
        return true;
      }
    }),
    companyType: Yup.mixed().test('companyType', 'Company type is required', (value) => {
      if (!value) {
        return false;
      } else {
        return true;
      }
    }),
    serviceType: Yup.mixed().test('serviceType', 'Service type is required', (value) => {
      if (value?.length > 0 || value?.serviceType) {
        return true;
      } else {
        return false;
      }
    }),
    clientName: Yup.string()
      .test('clientName', 'Client name already exist', (value) => !checkNameExist(value))
      .required('Client name is required')
      .max(50, 'Client name cannot exceed 50 characters'),
    clientNumber: Yup.string()
      .test('clientNumber', 'invalid client Code', (value) => !/[\\.-]/g.test(value))
      .test('clientNumber', 'client code already exist', (value) => !checkCodeExist(value))
      .max(4, 'Client Code cannot exceed 4 digits')
      .required('Client code is required'),

    contactName: Yup.string().max(50, 'Contact cannot exceed 50 characters'),
    addressLine1: Yup.string().max(50, 'Address Line 1 cannot exceed 50 characters'),
    addressLine2: Yup.string().max(50, 'Address Line 2 cannot exceed 50 characters'),
    zipCode: Yup.string().max(9, 'Zip code cannot exceed more than  9 characters'),
    city: Yup.string().max(20, 'City cannot exceed 20 characters'),
    ...validation,
  };

  const validationSchema = Yup.object().shape(validationShape);
  const {reusableInputStyles} = useContext(ThemeContext);
  const {setJustClientAdded} = useContext(SelectTabContextProvider);
  const classes = reusableInputStyles();

  const [client, setClient] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [change, setChange] = useState(false);
  const [submitData, setSubmitData] = useState('');
  useEffect(() => {
    if (clientGeneralStatus === 200) {
      history.push('/client-search');
      setJustClientAdded(true);
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetSubServiceTypes());
      }, 3000);
      dispatch(resetStatus());
    }
  }, [clientGeneralStatus]);
  useEffect(() => {
    dispatch(fetchDropDowns());
    dispatch(fetchClientService());
    dispatch(fetchClientParent());
    dispatch(fetchAllClientName({clientName: ''}));
  }, [dispatch]);
  const onSubmit = (data) => {
    const submitData = {...data};

    if (typeof data === 'object' && submitData.serviceType?.serviceTypeId) {
      submitData.serviceType = [data.serviceType];
    }
    setSubmitData(submitData);
    setIsOpen(true);
  };
  useEffect(() => {
    setClient(submitData);
  }, [submitData]);
  const debounceClientCode = (value) => {
    const data = {
      clientNumber: value,
    };
    dispatch(postClientCode(data));
  };

  useEffect(() => {
    dispatch(fetchAllClientCodes({clientNumber: ''}));
  }, []);

  const debounceClientName = (value, parentClientId1) => {
    const data = {
      clientName: value,
      parentClientId: parentClientId1.parentClientId,

    };
    dispatch(postClientName(data));
  };
  useEffect(() => {
    if (clientId?.parentClientId) {
      dispatch(getClientAddress(clientId?.parentClientId));
    }
    return () => {
      dispatch(resetClientAddress());
    };
  }, [dispatch, clientId]);

  useEffect(() => {
    return () => {
      dispatch(resetClientAddress());
    };
  }, [dispatch]);

  const handleSubServices = (type, values) => {
    const payload = {
      companyId: type,
      parentClientId: values.parentClientId.parentClientId,
    };
    dispatch(getServiceType(payload));
    dispatch(resetSubServiceTypes());
  };

  const handleSubServiceTypes = (data, position) => {
    let payload;

    if (typeof data === 'object' && data?.serviceTypeId) {
      payload = {serviceId: [data.serviceTypeId]};
    } else {
      const serviceTypeIds = data && data.length > 0 && data.map((item) => item.serviceTypeId);
      payload = {serviceId: serviceTypeIds};
    }

    dispatch(getSubServiceTypes(payload));
  };

  const selectedSubserviceTypes = (values) => {
    let subServiceTypeArray = false;
    subServiceTypes.length > 0 &&
      subServiceTypes.forEach((type, i) => {
        if (values[`selected${type?.subServiceTypeId}`] || values.companyType !== 'The WellFund, LLC') {
          subServiceTypeArray = true;
        }
      });
    return subServiceTypeArray;
  };
  const disabledByRole = roleData?.window?.['Client Maintenance']?.AC;

  const [blockScroll, setBlockScroll] = useState(false);
  return (
    <>
      <LandingPage showTabs={true}>
        <div className="global-field-dash-board">

          <div className={classes.cardBordernoneStyles} style={{position: blockScroll ? `fixed` : ``, width: blockScroll ? `95%` : ``}}>

            <div className="d-flex align-items-center mb-3"> <Button
              className={`search-btn`}
              variant="outlined"
              onClick={() => {
                history.push('/client-search');
              }}
            >
              <ArrowBack className="mr-2" />
            BACK TO DASHBOARD
            </Button>
            <Typography className="mb-2 ml-4 module-heading" variant="h1">
                        Add Client
            </Typography>
            </div>
            <div className={` mb-0`}>
              <Formik
                onSubmit={onSubmit}
                initialValues={initialVal}
                validationSchema={validationSchema}
                enableReinitialize
              >
                {(props) => {
                  const {
                    values,
                    setFieldValue,
                    handleReset,
                    handleBlur,
                    touched,
                    errors,
                  } = props;
                  return (
                    <Form noValidate autocomplete="off">

                      <div className="client-first-block">
                        <div className="form-row global-field-textfields">
                          <div className="col-lg-4 col-md-4 col-sm-6 form-group">
                            <FormControl margin="dense" variant="outlined" fullWidth>
                              <GuiAutoComplete
                                classes={{
                                  popper: classes.popper,
                                  option: classes.option,
                                }}
                                id="parentClientId"
                                options={getCommonOptions(clientParentData)}
                                size="small"
                                value={values.parentClientId}
                                autoHighlight
                                onBlur={handleBlur}
                                getOptionLabel={(option) => {
                                  return option?.parentClientName ? option.parentClientName : '';
                                }}
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={`${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Parent Client Name"
                                    label="Parent Client Name"
                                    onBlur={handleBlur}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    fullWidth
                                    required
                                    error={touched?.parentClientId && errors?.parentClientId}
                                    touched={touched && touched?.parentClientId}
                                  />
                                )}
                                onChange={(_, data) => {
                                  setFieldValue('parentClientId', data);
                                  setFieldValue('clientName', '');
                                  if (data?.parentClientId) {
                                    dispatch(getClientAddress(data.parentClientId));
                                  } else if (data?.parentClientId === '' || !data) {
                                    dispatch(resetClientAddress());
                                  }
                                }}
                              />
                            </FormControl>
                            <FormHelperText
                              margin="dense"
                              variant="outlined"
                            >
                              {touched?.parentClientId && errors?.parentClientId}
                            </FormHelperText>
                          </div>
                          {clientAddressData?.addressLine1 && (
                            <RenderAddress
                              addressData={clientAddressData}
                              dropDownData={dropDownData}
                              title="Parent Client Address"
                            />

                          )}
                          <div className="col-lg-4 col-md-3 col-sm-6 form-group">
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Client Name"
                              margin="dense"
                              name="clientName"
                              variant="outlined"
                              value={values.clientName}
                              label="Client Name"
                              disabled={values.parentClientId ? false : true}
                              onBlur={handleBlur}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                              onChange={(e) => {
                                setFieldValue('clientName', e.target.value);
                                setInputValue(e.target.value);
                                if (e.target.value) {
                                  debounceClientName(e.target.value, values.parentClientId);
                                } else if (e.target.value === '') {
                                  dispatch(resetNameCodes());
                                }
                              }}
                              required
                              error={touched.clientName && errors?.clientName}
                              touched={touched && touched?.clientName}
                            />
                            <FormHelperText variant="outlined">
                              {touched.clientName && errors.clientName}
                            </FormHelperText>
                            <div className="parentclient-popover">
                              {openMenu &&
                                clientNameData &&
                                clientNameData?.length > 0 &&
                                clientNameData?.map((data, i) => (
                                  <MenuItem key={i}>{data}</MenuItem>
                                ))}
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-3 col-sm-6 form-group">
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Client Code"
                              margin="dense"
                              fullWidth
                              name="clientNumber"
                              value={values.clientNumber}
                              variant="outlined"
                              label="Client Code"
                              required
                              error={touched.clientNumber && errors?.clientNumber}
                              touched={touched?.clientNumber}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onBlur={handleBlur}
                              InputProps={{
                                inputComponent: NumberOnly,
                              }}
                              onChange={(e) => {
                                setFieldValue('clientNumber', e.target.value);
                                setInputValue1(e.target.value);
                                if (e.target.value) {
                                  debounceClientCode(e.target.value);
                                } else if (e.target.value === '') {
                                  dispatch(resetClientCodes());
                                }
                              }}
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {checkCodeExist(values.clientNumber) ? 'client code already exist' : touched.clientNumber && errors.clientNumber}
                            </FormHelperText>
                            <div className="parentclient-popover">
                              {numberMenu &&
                                clientCodeData?.length > 0 &&
                                clientCodeData?.map((data, i) => (
                                  <MenuItem key={i}>{data.clientNumber}</MenuItem>
                                ))}
                            </div>
                          </div>
                          {/* Commented for future use */}
                          {/* <div className="col-md-2  col-sm-6 ">
                            <FormControl margin="dense">
                              <FormControlLabel
                                className={classes.checkRoot}
                                control={
                                  <Checkbox
                                    {...props}
                                    color="primary"
                                    checked={values.isActive}
                                    onChange={(e) => setFieldValue("isActive", e.target.checked)}
                                  />
                                }
                                label={"Active"}
                              />
                            </FormControl>
                          </div> */}
                          <div className="col-md-6 col-sm-6 form-group">
                            <FormControl margin="dense" variant="outlined" fullWidth>
                              <GuiAutoComplete
                                classes={{
                                  popper: classes.popper,
                                  option: classes.option,
                                }}
                                id={`companyType`}
                                value={values.companyType}
                                options={getCommonOptions(clientServiceData)}
                                size="small"
                                autoHighlight
                                disabled={!values.parentClientId}
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={`${classes.labelName} ${classes.selectLabel}`}
                                    {...params}
                                    variant="outlined"
                                    fullWidth
                                    label="Company Type"
                                    name={`companyType`}
                                    required
                                    error={touched?.companyType && errors?.companyType}
                                    // touched={touched && touched?.companyType}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    placeholder="Select Company Type"
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                  />
                                )}
                                onChange={(_, data) => {
                                  setFieldValue('companyType', data);
                                  setFieldValue('serviceType', []);
                                  setFieldValue(`subServiceType`, []);
                                  handleSubServices(data, values);
                                }}
                              />
                            </FormControl>
                            <FormHelperText variant="outlined">
                              {touched.companyType && errors.companyType}
                            </FormHelperText>
                          </div>
                          <div
                            className={`col-sm-12 col-lg-6 col-xl-6 form-group ${values.serviceType.length > 4 && `autocomplete-checkbox`
                            }`}
                          >
                            <FormControl margin="dense" variant="outlined" fullWidth>
                              <GuiAutoComplete
                                classes={{
                                  popper: classes.popper,
                                  option: classes.option,
                                }}
                                name="serviceType"
                                value={values.serviceType}
                                multiple={values.companyType !== 'The WellFund, LLC' ? true : false}
                                renderOption={(option, {selected}) => (
                                  <React.Fragment>
                                    {values.companyType !== 'The WellFund, LLC' && (
                                      <Checkbox
                                        icon={icon}
                                        checkedIcon={
                                          <CheckBoxIcon
                                            fontSize="small"
                                            className="selectcheckBox"
                                          />
                                        }
                                        checked={selected}
                                        className={classes.checkBox}
                                      />
                                    )}
                                    {option.serviceType}
                                  </React.Fragment>
                                )}
                                options={serviceTypes.length > 0 ? serviceTypes : []}
                                size="small"
                                autoHighlight
                                getOptionLabel={(option) => {
                                  if (
                                    values?.companyType === 'The WellFund, LLC' &&
                                    option?.length > 0
                                  ) {
                                    return option[0]?.serviceType;
                                  } else {
                                    return option && option.serviceType && option.serviceType;
                                  }
                                }}
                                renderInput={(params) => (
                                  <GuiTextField
                                    className={` multiselect-label ${classes.labelName} ${classes.selectLabel} ${classes.multiselectlabel}`}
                                    {...params}
                                    variant="outlined"
                                    fullWidth
                                    label="Service Type"
                                    defaultValue=""
                                    name={`serviceType`}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    required
                                    error={touched?.serviceType && errors?.serviceType}
                                    touched={touched && touched?.serviceType}
                                    placeholder="Select Service Type"
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: 'off', // disable autocomplete and autofill
                                    }}
                                  />
                                )}
                                error={touched.serviceType && errors?.serviceType}
                                touched={touched && touched?.serviceType}
                                onChange={(_, data, reason, detail) => {
                                  if (reason === 'clear') {
                                    setFieldValue('serviceType', []);
                                  } else {
                                    if (values.companyType === 'The WellFund, LLC') {
                                      setFieldValue('serviceType', [data]);
                                    } else {
                                      setFieldValue('serviceType', data);
                                    }
                                    handleSubServiceTypes(data);
                                  }
                                }}
                              />
                            </FormControl>
                            <FormHelperText variant="outlined">
                              {touched?.serviceType && errors?.serviceType}
                            </FormHelperText>
                          </div>
                        </div>
                        <div>
                          {(values.companyType && values.serviceType.length > 0) ||
                            (values?.serviceType?.serviceTypeId && subServiceTypes.length > 0) ? (
                              <ClientFormSubServiceTypeTable formik={props} setBlockScroll={setBlockScroll} blockScroll={blockScroll}/>
                            ) : null}
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mb-2">
                        <Button
                          type="button"
                          onClick={() => {
                            handleReset();
                            dispatch(resetSubServiceTypes());
                            dispatch(resetClientAddress());
                          }}
                          variant="outlined"
                          className={`mx-1 reset-btn ${classes.buttonRoot}`}
                        >
                          Cancel
                        </Button>
                        {selectedSubserviceTypes(values) ? (
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`mx-1 search-btn ${classes.buttonRoot}`}
                            disabled={!disabledByRole?.add}
                          >
                            Save
                          </Button>
                        ) : (
                          <Tooltip title="Please select atleast one sub service type to continue">
                            <span>
                              <Button
                                type="submit"
                                variant="outlined"
                                disabled
                                className={`mx-1 search-btn ${classes.buttonRoot}`}
                              >
                                Save
                              </Button>
                            </span>
                          </Tooltip>
                        )}
                      </div>
                    </Form>
                  );
                }}
              </Formik>
              <DialogBox title={change ? 'Copy Parent Address & Contacts' : 'Add Client'} open={isOpen} hideFooter={true}>
                <ClientConfirmationForm
                  setIsOpen={setIsOpen}
                  client={client}
                  change={change}
                  setChange={setChange}
                  submitData={submitData}
                />
              </DialogBox>
              {isLoading && <PageLoader />}
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
});

ClientForm.displayName = 'ClientForm';
export default ClientForm;
